export enum VariableStatus {
  UNDEFINED = 'UnDefined', // capital d?
  DEFAULT = 'Default',
  USER_SPECIFIED = 'UserSpecified',
  SOLVER_CALCULATED = 'SolverCalculated',
}
